import React, { Component } from 'react';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.date
        };
    }
    handleChange = (event, value) => {
        this.props.order(value);
    }
    render() {
        return (
            <div>
                <Toolbar>
                    <ToolbarGroup firstChild={true}>
                        
                    </ToolbarGroup>
                    <ToolbarGroup>
                        <ToolbarTitle text="Options" />
                        <ToolbarSeparator />
                        <IconMenu
                            iconButtonElement={<IconButton iconClassName="material-icons">sort</IconButton>}
                            onChange={this.handleChange}>
                            <MenuItem value="asc" primaryText="Game time, Ascending" />
                            <MenuItem value="desc" primaryText="Game time, Descending" />
                        </IconMenu>
                    </ToolbarGroup>
                </Toolbar>
            </div>
        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/menu.jsx